import { mapState } from 'vuex'
import ReportTable from '@/components/reports/table/ReportTable.vue'
import TableFilter from '@/components/common/tablefilter/TableFilter.vue'

export default {
  name: 'SummaryPlacedSimple',
  props: {
    client: Object,
    clientApiId: String,
    reportCode: String,
    activePeriodCode: String,
    reportpicker: {
      type: Boolean,
      default: false
    },
    scrollable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      reportData: null,
      curReportHelper: null,
      filterValues: {
        reportSubCodes: [],
        fromPeriod: null,
        toPeriod: null,
        precision: 2,
        multiply: 1
      },
      currentReq: null,
      mounted: false,
      loading: false,
      downloading: false
    };
  },
  components: {
    ReportTable,
    TableFilter
  },
  computed: {
    ...mapState(['config']),
    reportNameOptions () {
      return this.ZPFormatHelper.getReportNameOptions();
    },
    multiplyOptions () {
      return [
        { code: 1, text: this.$t('measure_types.multiply.1') },
        { code: 1000, text: this.$t('measure_types.multiply.1000') }
      ];
    },
    reportFilters () {
      const filters = {};
      filters.fromPeriod = { type: 'date-period', label: this.$t('general.filters.date-period-from') };
      filters.toPeriod = { type: 'date-period', label: this.$t('general.filters.date-period-to') };
      if (this.reportpicker) {
        filters.reportSubCodes = { type: 'checkbox', options: this.reportNameOptions, label: this.$t('report.title'), colclass: 'col-sm-6 col-md-4' }
      }
      filters.multiply = { type: 'select', label: this.$t('measure_types.multiply.title'), options: this.multiplyOptions };
      filters.precision = { type: 'number', label: this.$t('report.precision') };
      return filters;
    }
  },
  methods: {
    getTableData () {
      if (this.filterValues.reportSubCodes && this.filterValues.reportSubCodes.length > 0 && this.filterValues.fromPeriod && this.filterValues.toPeriod) {
        if (this.currentReq) {
          this.currentReq.cancel('changed search query');
        }
        this.loading = true;
        const self = this;
        let reqestPath = 'report/by-codes/' + this.filterValues.fromPeriod + '/' + this.filterValues.toPeriod;
        reqestPath += '?useGenerated=0&multiply=' + this.filterValues.multiply + '&&clientApiId=' + this.clientApiId + '&precision=' + this.filterValues.precision;
        if (this.filterValues.reportSubCodes.length > 0) {
          reqestPath += '&reportSubCodes=' + this.filterValues.reportSubCodes.join(';')
        }
        this.currentReq = this.ApiRequest.request(reqestPath, this.ApiRequest.REQUEST_GET, {}, function (response) {
          if (response.data) {
            self.ReportHelper.setParams(self.$options.filters, self);
            const precision = (self.filterValues.precision ? parseInt(self.filterValues.precision) : 0);
            const apiReports = {};
            Object.keys(response.data).forEach(subcode => {
              apiReports[subcode] = self.ReportHelper.createSummaryReport(response.data[subcode], precision)
            });
            self.reportData = apiReports;
            self.loading = false;
          }
        });
      }
    },
    getTableRowClass (item) {
      const periodData = this.BasicHelper.datePeriodCodeToData(item.periodId);
      if (periodData) {
        if (periodData.period === 0) {
          return 'summary-row colored';
        }
      }
      return '';
    },
    downloadSummaryReports () {
      this.downloading = true;
      const self = this;
      const reqData = { html: '', title: 'Novietotie materiāli: ' + this.client.name, filename: 'summary_' + this.client.id };
      this.$refs.summaryTableview.forEach(el => {
        if (reqData.html) {
          reqData.html += '<br pagebreak="true"/>';
        }
        reqData.html += '<div class="summary-report"><table>';
        el.$refs.tableview.childNodes[0].children[0].children.forEach(headerRow => {
          if (headerRow.innerText.trim() !== '') {
            reqData.html += headerRow.outerHTML;
          }
        });
        reqData.html += el.$refs.tableview.childNodes[0].children[1].innerHTML + '</table></div>';
      });
      this.ApiRequest.request('pdf-generator/from-html/L', this.ApiRequest.REQUEST_DOWNLOAD, reqData, function (response) {
        self.downloading = false;
      });
    },
    downloadSummaryExcel () {
      const tableData = {};
      const refs = this.$refs.summaryTableview;
      if (refs) {
        if (refs.innerHTML) {
          tableData[0] = refs.innerHTML;
        } else {
          refs.forEach((el, key) => {
            tableData[key] = el.$el.innerHTML;
          });
        }
      }
      this.BasicHelper.tablesToExcelFile(tableData, 'ZP_summary' + this.client.id + '_' + (new Date()).toISOString());
    }
  },
  mounted () {
    this.filterValues.toPeriod = this.activePeriodCode;
    const periodData = this.BasicHelper.datePeriodCodeToData(this.filterValues.toPeriod);
    this.filterValues.fromPeriod = (periodData.year - 2) + '0' + periodData.period + '0';
    if (this.reportCode) {
      this.filterValues.reportSubCodes = [this.reportCode.substr(0, this.reportCode.indexOf('_'))];
    }
    this.mounted = true;
    this.getTableData();
  }
}
